import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo_orizzontale_WHITE.png'


const _withScopeId = n => (_pushScopeId("data-v-a8c40734"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "it-header-slim-wrapper unige" }
const _hoisted_2 = {
  class: "container-fluid",
  style: {"padding":"0"}
}
const _hoisted_3 = {
  class: "d-flex justify-content-between align-items-center",
  style: {"height":"100%"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "it-brand-wrapper d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Università di Genova Logo",
    class: "unige-logo-header"
  })
], -1))
const _hoisted_5 = {
  class: "it-header-slim-right-zone d-flex align-items-center justify-content-end",
  style: {"margin-right":"0"}
}

import {ref, computed, onMounted, onBeforeMount} from "vue";
  import {ButtonUserLogin} from "cdp-fe-commons-layout";
import { setLocale } from "@/i18n"; // Import the setLocale function from i18n.js
import enFlag from '@/assets/flags/en-flag.jpg';
import itFlag from '@/assets/flags/it-flag.png';
import { useServiceDetailStore } from "@/stores/service/serviceDetail";
import {useUserStore} from "@/stores/user";
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    locked: { type: Boolean, default: false }
  },
  emits: ["clientHeight"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'clientHeight', height: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { locked: boolean }

const router = useRouter();

const serviceDetailStore = useServiceDetailStore();


const userref = ref<IUser>();
const firstname=ref('')
const lastname=ref('')
const userStore = useUserStore();
onBeforeMount(async () => {
 // userStore.getUser().then((userEl: IUser | undefined) => userref.value = userEl);
  const userdata = await userStore.getUser();
  if(userdata){
    userref.value = userdata;
    firstname.value=userdata.firstname
    lastname.value=userdata.lastname
  }
})

function showProfile() {
  router.push('/profilo')
}






const currentLocale = ref(localStorage.getItem("locale") || "en");
const currentFlag = computed(() => currentLocale.value === "en" ? 'EN' : 'IT');
const isDropdownOpen = ref(false);
function changeLocale(locale: string) {
  setLocale(locale);
  serviceDetailStore.setLanguage(locale)
  currentLocale.value = locale;
  localStorage.setItem("locale", locale); // Persist language choice
  toggleDropdown();
}

function toggleDropdown() {
  isDropdownOpen.value = !isDropdownOpen.value;
}

const classComp = computed(() => {
  return props.locked ? ' fixed-top' : '';
});


// Adjust Header Height
onMounted(() => {
  const el: HTMLElement | null = document.getElementById("headerCdp");
  if (el !== null) {
    emits("clientHeight", el.clientHeight);
  }
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass('it-header-wrapper' + _unref(classComp)),
    id: "headerCdp"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(ButtonUserLogin), {
              onShowProfile: showProfile,
              firstname: firstname.value,
              lastname: lastname.value,
              onLogout: _unref(userStore).logout
            }, null, 8, ["firstname", "lastname", "onLogout"])
          ])
        ])
      ])
    ])
  ], 2))
}
}

})